const { createStore, applyMiddleware } = require('redux');
const { default: thunk } = require('redux-thunk');
const { default: reducers } = require('./reducers');
const { composeWithDevTools } = require('redux-devtools-extension');

export const store = createStore(reducers, composeWithDevTools(applyMiddleware(thunk)));
